<template>
  <div class="localdata-container">
    <div class="show-label clearfix">
      <span v-for="n in selects">{{list[n][1]}}</span>
      <i class="el-icon-more" @click="dialogVisible = true"></i>
    </div>
    <el-dialog :title="title" v-model="dialogVisible" size="small">
      <table class="local-data-table">
        <colgroup>
          <col width="200px">
        </colgroup>
        <thead v-if="allowAll">
        <tr>
          <td class="select-all" colspan="2">
            <el-checkbox v-model="checkAll" label="全部"></el-checkbox>
          </td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="c in category">
          <th>{{list[c][1]}}</th>
          <td>
            <span class="local-data-item" :class="{active: selects.includes(k), disabled: disableSelect && !selects.includes(k) }" v-for="k in relations[c]">
              <template v-if="relations[k]">
                {{list[k][1]}}<i v-if="count(k)">{{count(k)}}</i>
                <div class="sub-list">
                  <label class="local-data-item" :class="{active: selects.includes(subK), disabled: disableSelect && !selects.includes(subK)}" v-for="subK in relations[k]"><input type="checkbox" v-model="selects" :value="list[subK][0]">{{list[subK][1]}}</label>
                </div>
              </template>
              <template v-else>
                <label><input type="checkbox" v-model="selects" :value="list[k][0]">{{list[k][1]}}</label>
              </template>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
      <p class="btn-bar">
        <span v-if="errorMsg" class="error-msg">{{errorMsg}}</span>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    compName: 'ee-localdata',
    props: {
      value: {
        type: Array,
        default () {
          return []
        }
      },
      title: {
        type: String
      },
      initialValue: {
        type: Array,
        default () {
          return []
        }
      },
      resource: {
        type: Object,
        required: true
      },
      allowAll: {
        type: Boolean,
        default: false
      },
      allValue: {
        type: [String, Number],
        default: '000'
      },
      max: {
        type: Number
      },
      min: {
        type: Number
      }
    },
    methods: {
      handleConfirm () {
        this.cache = [...this.selects]
        this.dialogVisible = false
      },
      handleCancel () {
        this.selects = [...this.cache]
        this.dialogVisible = false
      },
      count (k) {
        return this.relations[k].filter(id => this.selects.includes(id)).length
      }
    },
    data () {
      return {
        cache: [...this.value],
        selects: [...this.value],
        dialogVisible: false,
        checkAll: false,
        ...this.resource
      }
    },
    computed: {
      disableSelect () {
        return this.checkAll || this.selects.length === this.max
      },
      errorMsg () {
        if (this.min && this.selects.length < this.min) {
          return `请至少选择${this.min}项`
        }
        if (this.max && this.selects.length >= this.max) {
          return `最多只能选择${this.max}项`
        }
      }
    },
    watch: {
      checkAll () {
        if (this.checkAll) {
          this.selects = [this.allValue]
        } else {
          const tmp = [...this.cache]
          tmp.splice(tmp.indexOf(this.allValue), 1)
          this.selects = [...tmp]
        }
      },
      selects () {
        this.$emit('input', this.selects)
        this.$emit('change', this.selects)
      }
    }
  }
</script>
<style>
  .localdata-container {
    .show-label {
      position: relative;
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
      border: 1px solid #bfcbd9;
      border-radius: 4px;
      min-height: 36px;
      background-color: #fff;
      padding: 6px 20px 1px 10px;
      span {
        float: left;
        padding: 4px;
        margin-right: 5px;
        margin-bottom: 5px;
        background-color: #28a7e1;
        border-radius: 4px;
        line-height: 1;
        color: #fff;
      }
      i {
        right: 6px;
        top: 11px;
        color: #28a7e1;
        position: absolute;
      }
    }
    .el-dialog__header {
      padding: 5px 20px;
      border-top: 2px solid #34c1ea;
      background-color: #28a7e1;
      .el-dialog__title {
        color: #fff;
        font-size: 18px;
      }
      .el-icon {
        &:hover {
           color: #fff;
        }
      }
    }
    .local-data-table {
      td.select-all {
        padding: 10px;
      }
      th {
        text-align: center;
        vertical-align: middle;
        background-color: #fbfbfb;
      }
      td {
        padding: 25px;
      }
      th, td {
        border: 1px solid #ddd;
      }
    }
    .local-data-item {
      position: relative;
      float: left;
      padding: 3px 5px;
      margin-left: 5px;
      margin-bottom: 5px;
      font-size: 14px;
      line-height: 1;
      cursor: pointer;
      color: #28a7e1;
      i {
        padding: 0 3px;
        background-color: #28a7e1;
        color: #fff;
        font-style: normal;
      }

      &:hover, &.active {
        color: #fff;
        background-color: #28a7e1;
      }
      &:hover {
        .sub-list {
          display: block;
        }
      }
      &.disabled {
         cursor: not-allowed;
         color: #bfcbd9;
         background-color: #fff;
      }
      .sub-list {
        position: absolute;
        width: 500px;
        top: 100%;
        left: -100%;
        border: 1px solid #28a7e1;
        padding: 10px;
        background-color: #fbfbfb;
        z-index: 10;
        display: none;
      }
    }
    .btn-bar {
      padding: 10px;
      text-align: right;
      .error-msg {
        float: left;
        color: #f00;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/packages/localdata/LocalData.vue?0c5d0d1b